export const MERCHANT_PORTAL = 'Merchant Portal';
export const SIGN_UP_FOR_MERCHANT_ACCOUNT = 'Sign Up for Merchant Account';
export const LEGAL_ADDRESS = 'Legal Address';
export const CITY = 'City';
export const STATE = 'State';
export const ZIP_CODE = 'ZIP Code';
export const MERCHANT_SIGNEE_NAME = 'Merchant Signee Name';
export const SIGNEE_EMAIL = 'Signee Email';
export const SIGNEE_TITLE = 'Signee Title';
export const BILLING_CONTACT_NAME = 'Billing Contact Name';
export const BUSINESS_LEGAL_ENTITY_NAME = 'Business Legal Entity Name';
export const BILLING_EMAIL = 'Billing Email';
export const LOCATION_LIST = 'Location List';
export const FULL_LIST = 'Full list not required. Input text or upload a file below.';
export const LIST_OF_ADDRESSES = 'List of Addresses';
export const ACCEPTED_FORMATS = 'Accepted Formats: CSV, XLSX';
export const MAX_FILE_SIZE = 'Max file size: 2MB';
export const CANCEL = 'Cancel';
export const SIGN_UP = 'Sign Up';
export const SEND_A_COPY_OF_MY_RESPONSES = 'Send a copy of my responses';
export const DRAG_FILE_OR = 'Drag files here to upload or';
export const OR = 'or';
export const CHOOSE_FILE = 'Choose File';
export const FILE_SIZE_ERROR = 'File size must be less than 2MB';
export const FILE_TYPE_ERROR = 'Unsupported File Type';
export const FILE_CONTENT_ERROR = 'Invalid file contents. Please upload a new file';
export const PLEASE_ENTER = 'Please Enter';
export const ADDRESS_LIST_ERROR = 'Please Enter the Addresses or upload the file.'
export const AGREE_TEXT = `By clicking on Log in, You acknowledge 7-Eleven's `;
export const PRIVACY_POLICY = 'Privacy Notice';
export const AND = 'and agree to the ';
export const TERMS_OF_USE = '7NOW Merchant Portal Terms of Use.';
export const ADDITIONAL_INFORMATION = 'Additional Information (Optional)';
